/** CNPJ validation (with verifier digits check). */

export function validateCNPJ(value) {
  const cnpj = (value || "").replace(/\D/g, "");
  if (cnpj.length !== 14) return false;
  if (/^(\d)\1{13}$/.test(cnpj)) return false;
  const calc = (slice) => {
    let len = slice.length;
    let pos = len - 7;
    let sum = 0;
    for (let i = len; i >= 1; i--) {
      sum += parseInt(slice[len - i], 10) * pos--;
      if (pos < 2) pos = 9;
    }
    const result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    return result;
  };
  const t1 = cnpj.length - 2;
  const d1 = calc(cnpj.substring(0, t1));
  const d2 = calc(cnpj.substring(0, t1 + 1));
  return d1 === parseInt(cnpj[12], 10) && d2 === parseInt(cnpj[13], 10);
}

export function maskCNPJInput(v) {
  const d = (v || "").replace(/\D/g, "").slice(0, 14);
  if (d.length <= 2) return d;
  if (d.length <= 5) return `${d.slice(0, 2)}.${d.slice(2)}`;
  if (d.length <= 8) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5)}`;
  if (d.length <= 12) return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8)}`;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}

export function maskCEPInput(v) {
  const d = (v || "").replace(/\D/g, "").slice(0, 8);
  if (d.length <= 5) return d;
  return `${d.slice(0, 5)}-${d.slice(5)}`;
}

export async function fetchViaCEP(cep) {
  const d = (cep || "").replace(/\D/g, "");
  if (d.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    const data = await r.json();
    if (data.erro) return null;
    return data;
  } catch (e) {
    return null;
  }
}

/** Formata um CNAE de 7 dígitos "7112000" → "7112-0/00". */
export function formatCNAE(codigo) {
  const d = (codigo || "").replace(/\D/g, "");
  if (d.length !== 7) return codigo || "";
  return `${d.slice(0, 4)}-${d.slice(4, 5)}/${d.slice(5)}`;
}

/**
 * Consulta a Receita via OpenCNPJ (https://opencnpj.org) e retorna um objeto já
 * normalizado para o formulário de cliente. Retorna null se o CNPJ não for encontrado.
 */
export async function fetchOpenCNPJ(cnpj) {
  const d = (cnpj || "").replace(/\D/g, "");
  if (d.length !== 14) return null;
  try {
    const r = await fetch(`https://api.opencnpj.org/${d}`);
    if (!r.ok) return null;
    const j = await r.json();
    if (!j || !j.razao_social) return null;
    const cnaePrincipal = (j.cnaes || []).find((c) => c.is_principal) || (j.cnaes || [])[0] || {};
    const tel = (j.telefones || [])[0];
    const telefone = tel ? `(${tel.ddd}) ${tel.numero}` : "";
    const logradouro = [j.tipo_logradouro, j.logradouro].filter(Boolean).join(" ").trim();
    return {
      razao_social: j.razao_social || "",
      nome_fantasia: j.nome_fantasia || "",
      atividade_principal: cnaePrincipal.descricao || "",
      cnae: formatCNAE(j.cnae_principal || cnaePrincipal.codigo || ""),
      logradouro,
      numero: (j.numero || "").replace(/^0+/, "") || j.numero || "",
      complemento: (j.complemento || "").trim(),
      bairro: j.bairro || "",
      cep: maskCEPInput(j.cep || ""),
      municipio: j.municipio || "",
      uf: j.uf || "",
      telefone,
      email: (j.email || "").toLowerCase(),
      situacao: j.situacao_cadastral || "",
    };
  } catch (e) {
    return null;
  }
}
